(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-policy-page"] && !Shopify.designMode) return;
  try {
    const normalizeId = (value) => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);

  const structureTerms = (content) => {
    if (content.querySelector('h2, h3')) return;

    const source = content.textContent.replace(/\s+/g, ' ').trim();
    const markerPattern = /(?:^|\s)(GENERALIDADES|SECCI(?:Ó|O)N\s+\d+:|SECTION\s+\d+:)/giu;
    const markers = [...source.matchAll(markerPattern)];

    if (markers.length < 2) return;

    const fragment = document.createDocumentFragment();

    markers.forEach((marker, index) => {
      const markerText = marker[1];
      const start = marker.index + marker[0].length;
      const end = index + 1 < markers.length ? markers[index + 1].index : source.length;
      let sectionText = source.slice(start, end).trim();
      let headingText = markerText.replace(/:$/, '');

      if (!/^GENERALIDADES$/i.test(markerText)) {
        const titleMatch = sectionText.match(/^((?:[\p{Lu}\p{M}0-9 ,;:¿?¡!/&-]|\([^)]*\))+?)\s+(?=\p{Lu}\p{Ll})/u);

        if (titleMatch) {
          headingText = `${headingText}: ${titleMatch[1].trim()}`;
          sectionText = sectionText.slice(titleMatch[0].length).trim();
        }
      }

      const section = document.createElement('section');
      section.className = 'legal-policy__section';
      const heading = document.createElement('h2');
      heading.textContent = headingText;
      const paragraph = document.createElement('p');
      paragraph.textContent = sectionText;
      section.append(heading, paragraph);
      fragment.append(section);
    });

    content.replaceChildren(fragment);
  };

  const groupByHeadings = (content) => {
    const headings = [...content.querySelectorAll(':scope > h2')];

    headings.forEach((heading) => {
      if (heading.parentElement.classList.contains('legal-policy__section')) return;

      const section = document.createElement('section');
      section.className = 'legal-policy__section';
      heading.before(section);
      section.append(heading);

      while (section.nextSibling && !section.nextSibling.matches?.('h2')) {
        section.append(section.nextSibling);
      }
    });
  };

  document.querySelectorAll('.legal-policy').forEach((policy) => {
    const content = policy.querySelector('[data-policy-content]');
    const nav = policy.querySelector('[data-policy-nav]');
    const layout = policy.querySelector('.legal-policy__layout');

    if (!content || !nav || !layout) return;

    if (policy.dataset.policyType === 'terms') structureTerms(content);
    groupByHeadings(content);

    const headings = [...content.querySelectorAll('.legal-policy__section > h2')];

    if (!headings.length) {
      layout.classList.add('legal-policy__layout--without-nav');
      return;
    }

    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let id = normalizeId(heading.textContent) || `seccion-${index + 1}`;
      let suffix = 2;

      while (usedIds.has(id) || document.getElementById(id)) {
        id = `${normalizeId(heading.textContent) || `seccion-${index + 1}`}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(id);
      heading.id = id;
      heading.parentElement.setAttribute('aria-labelledby', id);
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent;
      nav.append(link);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
